import { type FC, type MouseEvent } from 'react';

import { Tag } from '@vakantiesnl/components/src/atoms/Tag';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';

import { useStyles } from './FilterLabel.style';
import { isZoover } from '../../utils';

interface Props {
	label: React.ReactNode;
	onCloseClick: (event: MouseEvent) => void;
	className?: string;
	qaTagValue: string;
	disabled: boolean;
}

export const FilterLabel: FC<Props> = ({ label, onCloseClick, className, qaTagValue, disabled }) => {
	const { classes, cx } = useStyles();
	const { isDesktop } = useBreakpoints();

	return (
		<div
			className={cx(classes.container, className, disabled ? classes.disabled : 'clear-button')}
			data-qa={qaTagValue}
			onClick={!disabled ? onCloseClick : undefined}
			aria-label="clear"
		>
			<Tag tailingIcon="cancel" size={isDesktop ? 'medium' : 'small'} color={isZoover ? 'orange' : 'teal'}>
				{label}
			</Tag>
		</div>
	);
};
